import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState, ReactNode } from "react";
import { supabase } from "./supabaseClient";
import CertificateVerify from "./pages/CertificateVerify";
import LoginPage from "./pages/LoginPage";
import AdminCertificates from "./pages/AdminCertificates";

function ProtectedRoute({ children }: { children: ReactNode }) {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkSession = async () => {
      const { data } = await supabase.auth.getSession();
      setIsAuthenticated(!!data.session);
      setLoading(false);
    };

    checkSession();

    const { data: listener } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setIsAuthenticated(!!session);
      }
    );

    return () => {
      listener.subscription.unsubscribe();
    };
  }, []);

  if (loading) return <div>Loading...</div>;

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <HashRouter>
      <Routes>
        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/verify" replace />} />

        {/* Public routes */}
        <Route path="/verify" element={<CertificateVerify />} />
        <Route path="/login" element={<LoginPage />} />

        {/* Protected admin dashboard */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <AdminCertificates />
            </ProtectedRoute>
          }
        />
      </Routes>
    </HashRouter>
  );
}
